function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-fill-green",
  d: "M7.92,8.71c1.85,0,3.35-1.5,3.35-3.35s-1.5-3.35-3.35-3.35s-3.35,1.5-3.35,3.35S6.08,8.71,7.92,8.71z  M7.92,4.02c0.74,0,1.35,0.6,1.35,1.35c0,0.74-0.6,1.35-1.35,1.35s-1.35-0.6-1.35-1.35C6.58,4.62,7.18,4.02,7.92,4.02z M4.2,16.53 h4.15v2H2.77l-0.25-0.63c-0.26-0.65-0.39-1.36-0.39-2.1c0-3.19,2.59-5.78,5.78-5.78c1.91,0,3.7,0.94,4.77,2.52l-1.65,1.13 c-0.71-1.03-1.87-1.65-3.12-1.65c-2.08,0-3.78,1.7-3.78,3.78C4.13,16.04,4.15,16.29,4.2,16.53z M16.2,12.29 c1.85,0,3.35-1.5,3.35-3.35S18.04,5.6,16.2,5.6s-3.35,1.5-3.35,3.35S14.35,12.29,16.2,12.29z M16.2,7.6c0.74,0,1.35,0.6,1.35,1.35 c0,0.74-0.6,1.35-1.35,1.35c-0.74,0-1.35-0.6-1.35-1.35C14.85,8.2,15.45,7.6,16.2,7.6z M16.2,13.6c-3.19,0-5.78,2.59-5.78,5.78 c0,0.74,0.13,1.44,0.39,2.1l0.25,0.63h10.28l0.25-0.63c0.26-0.65,0.39-1.36,0.39-2.1C21.98,16.19,19.38,13.6,16.2,13.6z  M19.91,20.11h-7.42c-0.04-0.24-0.07-0.48-0.07-0.73c0-2.08,1.7-3.78,3.78-3.78s3.78,1.7,3.78,3.78 C19.98,19.63,19.95,19.87,19.91,20.11z"
}));

var SvgIconUser = function SvgIconUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_user.ad6900c4.svg";
export { ForwardRef as ReactComponent };